import React, { createContext, useContext, useState } from 'react';

const LayoutContext = createContext();

export const LAYOUTS = {
  V1: 'v1',
  V2: 'v2'
};

export const LayoutProvider = ({ children }) => {
  const [currentLayout, setCurrentLayout] = useState(LAYOUTS.V1);

  return (
    <LayoutContext.Provider value={{ 
      currentLayout, 
      setCurrentLayout
    }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}; 